import $http, { Response as res, ResponseError } from '@packages/request'
import Response from './Response'

/**
 * 1. 系统正常就返回对应需要的数据
 * 2. 异常就返回异常 ResponseError
 * @param uri
 * @param params
 */
export default function<T>(uri: string, params: object) {
  return new Promise<Response<T>>((resolve, reject) => {
    const response: Response<T> = new Response<T>()
    $http
      .post(`${process.env.VUE_APP_HOST}${uri}`, params)
      /* eslint-disable @typescript-eslint/no-explicit-any */
      .then((data: res<any>) => {
        response.status.code = data.data.code
        response.status.message = ''
        response.status.errors = data.data.errors
        if (data.data.code !== 200) {
          resolve(response)
        } else {
          const keys = Object.keys(data.data.data)
          if (keys.length > 1) {
            response.data = data.data.data
          } else {
            response.data = data.data.data[keys[0]]
          }
          resolve(response)
        }
      })
      .catch((e: ResponseError<any>) => {
        response.status.httpCode = e.response?.status || 0
        Object.assign(response.status, e.response?.data)
        reject(response)
      })
  })
}
